export const routesRaporOverallAylik = [
  {
    path: "/rapor_overall_aylik",
    name: "rapor_overall_aylik",
    component: () => import("@/views/proje_alt/rapor_overall_aylik/index.vue"),
    meta: {
      public: false,
      title: "proje_alt.Overall Aylık Rapor",
      yetki: { k: [1012602] },
    },
  },
]
